function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 19V9M1 9V1.52839C1 1.23657 1.23657 1 1.52839 1H4.17157C5.98258 1 7.71942 1.71942 9 3C10.2806 4.28058 12.0174 5 13.8284 5H14.6477C14.8423 5 15 5.15771 15 5.35226V12.4067C15 12.7344 14.7344 13 14.4067 13H11.8284C10.0174 13 8.28058 12.2806 7 11C5.71942 9.71942 3.98258 9 2.17157 9H1Z",
  stroke: "#237804",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var SvgHomeFlag = function SvgHomeFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-flag.f5c319b2.svg";
export { ForwardRef as ReactComponent };